import { IAnalyticsUser } from '../../types/analytics';
import { TApplicationState } from '../../types/redux';
import { selectUser } from '../user';

export const selectAnalyticsUser = (state: TApplicationState): IAnalyticsUser => {
  const user = selectUser(state);

  if (!user.isAuthenticated) {
    return {};
  }

  return {
    userId: user.realtyUserId,
  };
};
